import { CourseInstanceResponse } from '../Types/CourseInstanceResponse';
import { courseInstanceInitState } from './CourseInitState';
import { IAction } from '../../../__core/Interfaces/IAction';
import COURSE_ACTIONS from '../Actions/ActionTypes';

export const courseInstanceReducer = (
  state: CourseInstanceResponse = courseInstanceInitState,
  action: IAction<CourseInstanceResponse>
): CourseInstanceResponse => {
  switch (action.type) {
    case COURSE_ACTIONS.FETCH_COURSE_INSTANCE:
      return { ...action.payload };

    default:
      return state;
  }
};
